export default "__VITE_ASSET__BA8b3KAk__"